export const testimonials = [
  {
    id: "t1",
    name: "María & José Fernández",
    context: { en: "First-time buyers · Kendall", es: "Compradores primerizos · Kendall" },
    quote: {
      en: "As first-time buyers we had a hundred questions. Carlos answered every single one — nights, weekends, whenever. We never felt rushed, and we never felt alone in the process.",
      es: "Como compradores primerizos teníamos cien preguntas. Carlos respondió cada una — noches, fines de semana, cuando fuera. Nunca nos sentimos presionados ni solos en el proceso.",
    },
  },
  {
    id: "t2",
    name: "Daniela Rojas",
    context: { en: "Seller · Coral Gables", es: "Vendedora · Coral Gables" },
    quote: {
      en: "Carlos priced our home with real data, marketed it beautifully, and had us under contract faster than we imagined. He treats your home like it's his own.",
      es: "Carlos puso precio a nuestra casa con datos reales, la presentó hermosamente y la tuvo bajo contrato más rápido de lo que imaginamos. Cuida tu casa como si fuera suya.",
    },
  },
  {
    id: "t3",
    name: "James & Lauren Whitfield",
    context: { en: "Relocation · Brickell", es: "Reubicación · Brickell" },
    quote: {
      en: "Moving from Chicago, we knew nothing about Miami. Carlos toured us through four neighborhoods, explained the real differences, and found us a condo we love. Responsive doesn't begin to cover it.",
      es: "Al mudarnos desde Chicago, no sabíamos nada de Miami. Carlos nos llevó por cuatro vecindarios, explicó las diferencias reales y nos encontró un condominio que amamos. Decir que responde rápido es quedarse corto.",
    },
  },
  {
    id: "t4",
    name: "Alejandro Paredes",
    context: { en: "Investor · Doral", es: "Inversionista · Doral" },
    quote: {
      en: "I've worked with agents who disappear after the contract. Carlos was at the inspection, at the appraisal, at closing. Fully hands-on from day one.",
      es: "He trabajado con agentes que desaparecen después del contrato. Carlos estuvo en la inspección, en la tasación, en el cierre. Totalmente involucrado desde el primer día.",
    },
  },
  {
    id: "t5",
    name: "Sofía Mendoza",
    context: { en: "First-time buyer · Coconut Grove", es: "Compradora primeriza · Coconut Grove" },
    quote: {
      en: "He explained everything in Spanish and English so my whole family understood each step. That meant the world to us. We felt taken care of, not sold to.",
      es: "Explicó todo en español e inglés para que toda mi familia entendiera cada paso. Eso significó el mundo para nosotros. Nos sentimos cuidados, no vendidos.",
    },
  },
  {
    id: "t6",
    name: "Robert Chen",
    context: { en: "Seller & buyer · Miami Beach", es: "Vendedor y comprador · Miami Beach" },
    quote: {
      en: "Carlos sold our place and found us the next one in the same month. His energy is unmatched — you get the feeling he genuinely loves this work, and it shows in the results.",
      es: "Carlos vendió nuestra propiedad y nos encontró la siguiente en el mismo mes. Su energía no tiene igual — se nota que ama este trabajo, y se refleja en los resultados.",
    },
  },
];
